import { Component, ViewChild, ViewChildren, OnInit, QueryList, ElementRef, AfterViewInit, PACKAGE_ROOT_URL, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { PageEvent, MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

//import { Abstract } from '../../../models/abstract/abstract.model';

import { AbstractKappas } from '../../../models/abstract/abstract-kappas.model';
import { AbstractKappasFlatten } from '../../../models/abstract/abstract-kappas-flatten.model';



import { AbstractSearchResult } from '../../../models/abstract/abstract-search-result.model';
import { AbstractSearchKeys } from '../../../models/abstract/abstract-search.model';
import { GenericSelectOption } from '../../../models/generic-select-option.model';
import { AbstractSearchMetadata } from '../../../models/abstract/abstract-search-metadata.model';
import { MenuFilterOption } from '../../../models/menu/menu-filter-option.model';
import { MenuActionOption } from '../../../models/menu/menu-action-option.model';
import { ActionAbstracts } from '../../../models/abstract/action-abstracts.model';


import { AbstractService } from '../../../services/abstract.service';
import { AccountService } from "../../../services/account.service";
import { AuthService } from "../../../services/auth.service";
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { ReportService } from '../../../services/report.service';
import { Utilities } from '../../../services/utilities';

import { merge, Observable, Subject, of as observableOf, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap, debounceTime, takeUntil } from 'rxjs/operators';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DecisionBottomSheetComponent } from '../../bottom-sheet/decision-bottom-sheet/decision-bottom-sheet.component';

import { HttpClient } from '@angular/common/http';


import { ExcelService } from '../../../services/excel.service';
import { Roles } from '../../../models/enums';
import { FullProtocol } from '../../../models/protocol/full-protocol.model';
import { ProtocolService } from '../../../services/protocol.service';
import { User } from '../../../models/user.model';
import { QcWeekDay } from '../../../models/report/qc-week-day.model';
import { isNull, isUndefined } from 'util';
import { ConfirmBottomSheetComponent } from '../../bottom-sheet/confirm-bottom-sheet/confirm-bottom-sheet.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
//import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { AllCommunityModule, ModuleRegistry, GridOptions } from 'ag-grid-community';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { MatCheckboxModule } from '@angular/material/checkbox';

ModuleRegistry.registerModules([AllCommunityModule]);

interface MechGrpItem {
  title: string;
  rate: number;
  ingrpcount: number;
  ingrpabpros: AbstractKappas[];
  sampleN: number;
  qcselectedcount: number;
}

@Component({
  selector: 'app-search-abstracts',
  templateUrl: './search-abstracts.component.html',
  styleUrls: ['./search-abstracts.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
    //MatTableModule,
    ReactiveFormsModule,
    AgGridAngular,
    AgGridModule
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])]
})
export class SearchAbstractsComponent implements OnInit, AfterViewInit, OnDestroy {

  abstractCount: number = 10;
  abstractsPerPage: number = 10;
  showPaginator: boolean = true;
  recordsCount: number;

  isAdmin: boolean = false;
  isOdpSupervisor: boolean = false;
  isOdpStaff: boolean = false;
  isCoderSupervisor: boolean = false;
  isCoder: boolean = false;
  isRecCoder: boolean = false;

  roles: string[] = [];
  isSupervisorView: boolean = false;
  isStaffView: boolean = false;
  isListView: boolean = false;
  viewChanged: boolean = false;
  qcViewQcList: boolean = false;
  qcViewCoderQList: boolean = false;
  qcViewFiltered: boolean = false;

  protocols: FullProtocol[] = [];
  protocolSelected: number = 0;
  protocolSelectedTitle: string = "";

  westatCoders: User[] = [];
  selectedCoders: number[] = [];
  weeks: QcWeekDay[] = [];
  dates: { text: string, value: QcWeekDay }[];
  selectedStartWeek: QcWeekDay;
  selectedEndWeek: QcWeekDay;
  invalidEndDate: boolean = false;
  qcAltView1DisplayText: string = "";
  qcAltView2DisplayText: string = "";
  qcFiltersDisplayText: string = "";
  qcFilterCountsDisplayText: string = "";
  qcMechGrps: MechGrpItem[] = [];
  abstractTeams: number[] = [];
  unfiltAllCount: number = 0;
  unfiltQCCount: number = 0;
  unfiltCoderqCount: number = 0;
  isFiltCountAlert: boolean = false;

  loadingIndicator: boolean = false;
  filteroptions: GenericSelectOption[] = [];
  actionoptions: GenericSelectOption[] = [];
  abstractsData: AbstractSearchResult = new AbstractSearchResult();
  //abProIdsFullForQCReset: number[] = [];
  abProIdsFullQCEligPoolCurrent: number[] = [];
  //abstracts: Abstract[] = [];
  metadata: AbstractSearchMetadata;
  abstractSearchKeys: AbstractSearchKeys = new AbstractSearchKeys();
  filterOptionSelected: string = "";
  searchTerm: string = "";
  private subject: Subject<string> = new Subject();
  actionOptionSelected: string = "";
  resultsLength: number = 0;
  isLoadingResults: boolean = true;
  isRateLimitReached: boolean = false;
  selectedRowIndex: number = -1;
  filterByProtocol: boolean = false;
  activeProjectTitle: string;

  private destroy$: Subject<void> = new Subject();

  pageSize = 25;

  colDefsDefault: ColDef[] = [
    { headerName: "Abstract Status", field: "abstractStatusDescription", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 144 },
    { headerName: "Application ID", field: "application", filter: 'agTextColumnFilter', autoHeight: true , wrapText: true, minWidth: 124 },
    { headerName: "Project Number", field: "projectNumber", filter: 'agTextColumnFilter', autoHeight: true , wrapText: true, minWidth: 126 },
    { headerName: "FY", field: "fy", filter: 'agTextColumnFilter', autoHeight: true , wrapText: true, minWidth: 88 },
    { headerName: "Type", field: "type", filter: 'agTextColumnFilter', autoHeight: true , wrapText: true, minWidth: 88 },
    { headerName: "Mech", field: "mechanism", filter: 'agTextColumnFilter', autoHeight: true , wrapText: true, minWidth: 88 },
    {
      headerName: "Status Date", field: "statusDate", autoHeight: true, wrapText: true, minWidth: 111, filter: 'agDateColumnFilter', valueFormatter: params => {
        if (!params.value) return '';
        const date = new Date(params.value);
        return date.toLocaleString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }).replace(/,/g, "");
      } },
    {
      headerName: "Title", field: "projectTitle", filter: 'agTextColumnFilter', autoHeight: true , wrapText: true, minWidth: 250, cellRenderer: params => {
        const rowData = params.data;
        return `<u style="color:blue">
            ${params.value}
            (${rowData.abstractStatusTitle})
          </u>`;
      }, onCellClicked: (event) => {
        const data = event.node.data;
        setTimeout(() => {
          this.checkAbstractForCodingBeforeNavigate(data.abstractId, data.projectTitle);
          this.loadingIndicator = false;
          this.isLoadingResults = false;
        }, 0);
        
      }
    },
    { headerName: "PI Name", field: "piProjectLeader", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 110 },
    // { headerName: "Flags", field: "flags", minWidth: 90 },
    {
      headerName: "QC Coder Question", field: "reviewRecommended", filter: 'agTextColumnFilter', autoHeight: true, wrapText: true, minWidth: 115, headerClass: 'wrap-header-text', cellRenderer: params => {
        if (params.value === true) {
          return 'Yes';
        } else if (params.value === false) {
          return 'No';
        }
        return ''; // Handle null or undefined values if needed
      }
    },
    {
      headerName: "ODP Adjudication", filter: 'agTextColumnFilter', field: "adjudicationRecommended", autoHeight: true, wrapText: true, minWidth: 138, cellRenderer: params => {
        if (params.value === true) {
          return 'Yes';
        } else if (params.value === false) {
          return 'No';
        }
        return ''; // Handle null or undefined values if needed
      }
    },
    {
      headerName: "A", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].a) {
          return Math.round(kappaData[0].a * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
    {
      headerName: "B", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].b) {
          return Math.round(kappaData[0].b * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
    {
      headerName: "C", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].c) {
          return Math.round(kappaData[0].c * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
    {
      headerName: "D", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].d) {
          return Math.round(kappaData[0].d * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
    {
      headerName: "E", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].e) {
          return Math.round(kappaData[0].e * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
    {
      headerName: "F", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].f) {
          return Math.round(kappaData[0].f * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
    {
      headerName: "X", field: "kappaData", filter: 'agTextColumnFilter', minWidth: 70, autoHeight: true, wrapText: true, cellRenderer: params => {
        const kappaData = params.value;
        if (kappaData && kappaData[0] && kappaData[0].x) {
          return Math.round(kappaData[0].x * 100) / 100;
        }
        else {
          return '';
        }
      }
    },
  ];

  defaultColDef: ColDef = {
    wrapHeaderText: true,
    autoHeaderHeight: true,
  };
  gridOptions: GridOptions = {
    autoSizeStrategy: {
      type: 'fitGridWidth'
    },
    enableCellTextSelection: true,
    suppressColumnVirtualisation: true,
    rowSelection: {
      mode: 'multiRow',
      checkboxes: true,
      headerCheckbox: true,
      enableClickSelection: false,
    },
    onRowSelected: (event) => {
      if (event.node.isSelected()) {
        this.selection.select(event.node.data)
      } else {
        this.selection.deselect(event.node.data)
      }
    },
    /*pagination: true,
    paginationPageSizeSelector: [10, 25, 50, 100, 250, 500],
    paginationPageSize: 10,
    onPaginationChanged: (event) => {
      const api = event.api;
      const currentPage = api.paginationGetCurrentPage();
      const pageSize = api.paginationGetPageSize();
      if (this.abstractSearchKeys.pageNumber != currentPage || this.abstractSearchKeys.pageSize != pageSize) {
        this.abstractSearchKeys.pageNumber = currentPage;
        this.abstractSearchKeys.pageSize = pageSize;
        this.loadAbstractData(this.protocolSelected);
      }
    },*/
    //rowModelType: "infinite",
    domLayout: 'autoHeight',
    //onVirtualColumnsChanged: (event) => {
    //  var gridRules = event.api.autoSizeAllColumns();
    //},
    suppressMovableColumns: true
  };

  dataSource: AbstractKappas[] = []; //this.abstractsData.abstracts; /*new MatTableDataSource<Abstract>();*/
  rowData = [];
  colDefs: ColDef[] = this.colDefsDefault;
  selection = new SelectionModel<AbstractKappas>(true, []);

  // Tracks subscriptions in the loadAbstractData method and
  // unsubscribes to old calls if the last call is incomplete
  loadAbstractDataSubTrack: Subscription | null = null;

  // MatPaginator Output
  pageEvent: PageEvent;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();;
  //@ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSelect) matSelectFilter: MatSelect;

  constructor(private abstractService: AbstractService,
    private alertService: AlertService,
    private accountService: AccountService,
    private authService: AuthService,
    private reportService: ReportService,
    public router: Router,
    private activeRoute: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private http: HttpClient,
    private excelService: ExcelService,
    private protocolService: ProtocolService) {
      
      // Remove QC Coder Question and ODP adjudication if the role is rec coder
      // 10/10/2025 Commenting this out for now per Glenn's note on the issue in gitlab

      // let role = this.accountService.GetActiveRole();
      // if (role == Roles.ReconciliationCoder){
      //   this.isRecCoder = true;
      //   this.colDefsDefault.splice(9, 2); 
      // }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportAsXLSX(): void {

    var toExportJson = [];

    this.selection.selected.forEach(function (obj: AbstractKappas) {

      var flatten: AbstractKappasFlatten = new AbstractKappasFlatten();

      flatten.ApplicationID = obj.application;
      flatten.ReviewRequested = obj.reviewRecommended.toString(); /// coders requested ODP review (coding) of abstract
      flatten.InQcList = obj.inReviewList.toString(); /// abstract was selected for QC List (random ODP coding)
      //flatten.SubCategoryGroup = obj.subcategoryGroupTitle;
      //flatten.QcSampleRate = obj.samplingRate.toString() + "%";
      flatten.Coders = obj.coderTeamUsers;
      flatten.ProjectNumber = obj.projectNumber;
      flatten.FY = obj.fy;
      flatten.Type = obj.type;
      flatten.Mech = obj.mechanism;
      flatten.StatusDate = obj.statusDate;
      flatten.PIName = obj.piProjectLeader;
      flatten.Title = obj.projectTitle;
      flatten.Description = obj.descPart;
      flatten.PublicHealthPart = obj.publicHealthPart;
      flatten.HasNotes = obj.flags; /// obj.flags is populated in AutoMapperProfile.cs - if any note records, then "Yes"
      if (obj.kappaData.length > 0) {
        //flatten.A1 = `${obj.kappaData[0].a1}`;
        //flatten.A2 = `${obj.kappaData[0].a2}`;
        //flatten.A3 = `${obj.kappaData[0].a3}`;
        flatten.A = `${obj.kappaData[0].a}`;
        flatten.B = `${obj.kappaData[0].b}`;
        flatten.C = `${obj.kappaData[0].c}`;
        flatten.D = `${obj.kappaData[0].d}`;
        flatten.E = `${obj.kappaData[0].e}`;
        flatten.F = `${obj.kappaData[0].f}`;
        flatten.X = `${obj.kappaData[0].x}`;
        //flatten.G = `${obj.kappaData[0].g}`;
      }
      flatten.InQcList = obj.inReviewList.toString(); /// abstract was selected for Reconciliation List (random ODP coding)
      flatten.ReviewRequested = obj.reviewRecommended.toString(); /// coders requested ODP review (coding) of abstract
      flatten.AdjudicationRequested = obj.adjudicationRecommended.toString();
      flatten.SubmissionAgreePriorityTitle = obj.submissionAgreePriorityTitle.toString();
      //flatten.QcSampleRate = obj.samplingRate.toString() + "%";
      flatten.SubcategoryGroupTitle = obj.subcategoryGroupTitle;
      flatten.Coders = obj.coderTeamUsers;

      toExportJson.push(flatten);
    })

    /// [BJL 2025-09-23] Note that the columns in the Excel export, both number of columns and their order,
    /// are determined by the attributes the AbstractKappasFlattenRecon class. It doesn't matter what values you set 
    /// in "flatten" (above), or the order in which you set them - you must make sure that the columns in renameColHeaders
    /// correspond to those in AbstractKappasFlattenRecon.
    var renameColHeaders = [];
    renameColHeaders.push("Application ID");
    renameColHeaders.push("Project Number");
    renameColHeaders.push("FY");
    renameColHeaders.push("Type");
    renameColHeaders.push("Mechanism");
    renameColHeaders.push("Status Date");
    renameColHeaders.push("Title");
    renameColHeaders.push("PI Project Leader");
    renameColHeaders.push("Description");
    renameColHeaders.push("Public Health Part");
    renameColHeaders.push("Has QC Coder Notes");
    renameColHeaders.push("A");
    renameColHeaders.push("B");
    renameColHeaders.push("C");
    renameColHeaders.push("D");
    renameColHeaders.push("E");
    renameColHeaders.push("F");
    renameColHeaders.push("X");
    renameColHeaders.push("In Reconciliation List");
    renameColHeaders.push("QC Coder Question");
    renameColHeaders.push("Request ODP Adjudication");
    renameColHeaders.push("ML Agreement");
    renameColHeaders.push("SubCategory Group");
    renameColHeaders.push("QC Coders");

    this.excelService.exportAsExcelFile(toExportJson, 'AbstractExport', renameColHeaders);
  }

  selectProtocol(protocol: FullProtocol): void {
    this.paginator.forEach(p => p.pageIndex = 0);
    this.abstractSearchKeys.pageNumber = 0;
    this.loadAbstractSearchMetaData(protocol.id);
    this.loadAbstractData(protocol.id);
  }

  public ngOnInit(): void {
    if (this.authService.isSessionExpired) {
      console.log(`ABSTRACT LIST: REDIRECT TO LOGIN`);
      this.router.navigateByUrl('/account/login');
    }
    else {
      this.activeRoute.paramMap.subscribe((paramMap) => {
        var viewParam = paramMap.get('view');
        this.isSupervisorView = viewParam == "sup";
        this.isStaffView = viewParam == "staff";

        this.abstractCount = 10;
        this.abstractsPerPage = 10;
        this.showPaginator = true;
        this.filterOptionSelected = "";
        this.selectedCoders = [];
        this.selectedStartWeek = null;
        this.selectedEndWeek = null;
        this.invalidEndDate = false;
        ///[Notes:BJL_2024-05-08] Change filterByProtocol to default to true
        this.filterByProtocol = true;

        this.abstractSearchKeys = new AbstractSearchKeys();
        if (this.accountService.GetActiveProject()) {
          this.abstractSearchKeys.odpProjectWorkflowId = this.accountService.GetActiveProject().odpProjectWorkflowId;
        }
        else {
          this.abstractSearchKeys.odpProjectWorkflowId = 0;
        }
        this.abstractSearchKeys.odpUncodedOnly = false;
        this.abstractSearchKeys.pageSize = 25;
        this.abstractSearchKeys.pageNumber = 0;
        this.abstractSearchKeys.sortColumnName = "application";
        this.abstractSearchKeys.sortDirection = "desc";

        this.viewChanged = false;
        this.isListView = true;
        this.colDefs = this.colDefsDefault;
        this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
        this.abstractSearchKeys.excludeAbstractsInQcList = false;

        this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
        this.abstractSearchKeys.excludeAbstractsInQcList = false;

        this.isAdmin = this.accountService.IsAdminRole();
        this.isOdpSupervisor = this.accountService.IsOdpSupervisorRole();
        this.isOdpStaff = this.accountService.IsOdpStaffRole();
        this.isCoderSupervisor = this.accountService.IsCoderSupervisorRole();
        this.isCoder = this.accountService.IsCoderRole();
        this.activeProjectTitle = this.accountService.GetActiveProject() ? this.accountService.GetActiveProject().projectTitle : "";
        if (this.viewChanged) {
          this.initializeAbstractSearchMetadata();
        };
        if (this.metadata && this.metadata.menuFilterOptions) {
          this.processMetadata();
          this.loadAbstractData(this.protocolSelected);
        }
      });

      if (!this.isAdmin
        && !this.isOdpSupervisor
        && !this.isOdpStaff
        && !this.isCoderSupervisor
        && !this.isCoder)
        this.router.navigateByUrl('/home/actions');
    }
  }

  public ngAfterViewInit() {
    //this.protocolService.getProtocols().subscribe(protocolResult => {
    //  this.protocols = protocolResult;
    //  if (protocolResult.length > 0) {
    //    var protocolSelectedObject = protocolResult.find(p => p.isDefault == true)
    //    if (protocolSelectedObject) {
    //      this.protocolSelected = protocolSelectedObject.id;
    //      this.protocolSelectedTitle = protocolSelectedObject.title;
    //      this.loadAbstractSearchMetaData(this.protocolSelected);
    //    }
    //  }
    //},
    //error => {
    //  this.alertService.showStickyMessage(
    //    'Protocol Load Error',
    //    `Unable to retrieve protocols from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
    //    MessageSeverity.error, error);
    //  });

    this.initializeAbstractSearchMetadata();

    //this.sort.sortChange.subscribe(() => {
    //  this.paginator.forEach(p => p.pageIndex = 0);
    //  this.abstractSearchKeys.sortColumnName = this.sort.active;
    //  this.abstractSearchKeys.sortDirection = this.sort.direction;
    //  this.loadAbstractData(this.protocolSelected);
    //});

    this.subject.pipe(debounceTime(1000)).subscribe(() => {
      this.abstractSearchKeys.pageNumber = 0;
      this.paginator.forEach(p => p.pageIndex = 0);
      this.loadAbstractData(this.protocolSelected);
    });

    this.paginator.forEach(p => p.page.subscribe(() => {
      this.abstractSearchKeys.pageNumber = p.pageIndex;
      this.abstractSearchKeys.pageSize = p.pageSize;
      this.loadAbstractData(this.protocolSelected);
    }));

    // this.matSelectFilter.valueChange.subscribe((filter) => {
    // Abstract actions are for ODP Supervisor only
    // Commented out for testing
    // if (this.accountService.IsOdpSupervisorRole()) {
    // });
  }

  checkAbstractForCodingBeforeNavigate(abstractId: string, projectTitle: string) {
    console.log(`current view is staff: ${this.isStaffView}`);
    //event.stopPropagation();

    var currentRole = this.accountService.GetActiveRole();

    if (currentRole == Roles.ReconciliationCoder || currentRole == Roles.ReconciliationSupervisor) {
      this.checkIfAbstractBeingCoded(abstractId, projectTitle);
    }
    else {
      window.open(`#/abstract/view/${abstractId}`, "_blank");
    }
  }

  public clearSearchTerm() {
    this.searchTerm = "";
    this.abstractSearchKeys.abstractEnteredSearchFilter = "";
    this.loadAbstractData(this.protocolSelected);
  }

  public checkIfAbstractBeingCoded(abstractId: string, projectTitle: string) {

    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;
    this.isLoadingResults = true;

    if (this.accountService.GetActiveTeam() && this.accountService.GetActiveTeam().teamId > 0 && this.accountService.GetActiveRole() != Roles.ReconciliationSupervisor) {
      var absIdInt = parseInt(abstractId);

      this.abstractService.getOpenAbstract(this.accountService.GetActiveRole(), this.accountService.GetActiveTeam() ? this.accountService.GetActiveTeam().teamId : 0, absIdInt)
        .subscribe({
          next: abstractInCoding => {
            this.alertService.stopLoadingMessage();
            this.loadingIndicator = false;

            if (abstractInCoding && abstractInCoding.abstractId && abstractInCoding.abstractId != null && abstractInCoding.abstractId != 0) {
              if (abstractInCoding.abstractId == abstractId) {
                window.open(`#/abstract/view/${abstractId}`, "_blank");
              }
              else {
                //TODO
                this.alertService.stopLoadingMessage();

                let message = 'A team member has already opened another abstract for Coding. You will be redirected to Abstract &nbsp;<i>"' + abstractInCoding.abstract.projectTitle + '"</i>';

                this.openDecisionBottomSheet('Other opened abstract for coding', message, abstractInCoding.abstractId);

                this.loadingIndicator = false;
                this.isLoadingResults = false;

              }
            }
            else {
              window.open(`#/abstract/view/${abstractId}`, "_blank");
            }



          }, error: error => {
            this.alertService.stopLoadingMessage();
            this.loadingIndicator = false;
            this.alertService.showStickyMessage("Load Error", `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
              MessageSeverity.error, error);
          }
        });
    }
    else {
      window.open(`#/abstract/view/${abstractId}`, "_blank");
      this.alertService.stopLoadingMessage();
    }
  }

  openDecisionBottomSheet(sheetTitle: string, sheetText: string, abstractId: number): void {

    this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: sheetTitle,
        sheetHtml: sheetText
      },
      closeOnNavigation: true
    }).afterDismissed().subscribe(isOk => {
      if (isOk) {
        window.open(`#/abstract/view/${abstractId}`, "_blank");
      }
    });
  }

  loadAbstractData(protocolId) {
    if (this.loadAbstractDataSubTrack !== null) {
      this.loadAbstractDataSubTrack.unsubscribe();
      this.alertService.stopLoadingMessage();
      this.loadAbstractDataSubTrack = null;
    }

    this.alertService.startLoadingMessage();
    this.isLoadingResults = true;
    var selectedabs = this.selection.selected;

    this.abstractSearchKeys.protocolId = protocolId;
    this.abstractSearchKeys.filterByProtocol = this.filterByProtocol;

    /// Get abstracts for display in view list (10 or selected N)
    this.loadAbstractDataSubTrack = this.abstractService.getAbstractsByParams(this.abstractSearchKeys).pipe(takeUntil(this.destroy$)).subscribe({
      next: abstractsData => {
      this.alertService.stopLoadingMessage();
      this.loadingIndicator = false;
      this.isLoadingResults = false;
      this.isRateLimitReached = false;

      this.abstractsData = abstractsData;
      this.dataSource = abstractsData.abstractResult;
      this.rowData = this.dataSource;
    }, error: error => {
      this.alertService.stopLoadingMessage();
      this.loadingIndicator = false;
      this.alertService.showStickyMessage('List View Load Error',
        `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
        MessageSeverity.error, error);
    }});


    selectedabs.forEach((selab) => {
      this.selection.deselect(selab);
    })

  }

  public filterByProtocolChange(event: any) {
    console.log(event);
    this.abstractSearchKeys.pageNumber = 0;
    this.paginator.forEach(p => p.pageIndex = 0);
    this.loadAbstractSearchMetaData(this.protocolSelected);
  }

  public searchTermChange(event: any) {
    this.searchTerm = event.target.value;
    var trimmedTerm = this.searchTerm.trim();
    //This is to delay the load abstract execution until user stops typing
    this.abstractSearchKeys.abstractEnteredSearchFilter = trimmedTerm;
    this.subject.next(trimmedTerm);
  }

  //loads the metadata of the abstract search page
  public loadAbstractSearchMetaData(protocolId) {
    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;

    var odpProjectWorkflowId = 0
    if (this.accountService.GetActiveProject()) {
      odpProjectWorkflowId = this.accountService.GetActiveProject().odpProjectWorkflowId;
    }

    this.abstractService.getAbstractSearchMetadata(this.accountService.GetActiveRole(), protocolId, odpProjectWorkflowId, this.filterByProtocol)
      .subscribe({
        next: metadata => {
        this.alertService.stopLoadingMessage();
        this.loadingIndicator = false;
        this.metadata = metadata; //Make it local scope so other functions can utilize it 
        this.processMetadata();
        this.loadAbstractData(this.protocolSelected);
      }, error: error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.alertService.showStickyMessage("Search Metadata Load Error", `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }});
  }

  //// (re-)initializes AbstractSearchMetadata
  public initializeAbstractSearchMetadata() {
    /// Instead of letting user select a protocol, we are now getting it from the selected active project
    this.protocolSelected = this.accountService.GetActiveProject().protocolId;
    this.loadAbstractSearchMetaData(this.protocolSelected);
    //this.protocolService.getProtocols().subscribe({
    //  next: protocolResult => {
    //  this.protocols = protocolResult;
    //  if (protocolResult.length > 0) {
    //    var protocolSelectedObject = protocolResult.find(p => p.isDefault == true)
    //    if (protocolSelectedObject) {
    //      this.protocolSelected = protocolSelectedObject.id;
    //      this.protocolSelectedTitle = protocolSelectedObject.title;
    //      this.loadAbstractSearchMetaData(this.protocolSelected);
    //    }
    //  }
    //}, error: error => {
    //    this.alertService.showStickyMessage(
    //      'Protocol Load Error',
    //      `Unable to retrieve protocols from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
    //      MessageSeverity.error, error);
    //  }});
  }


  ////Load actions for the action list Select based on the filter Select selection 
  public loadActions(actionType: string, recordsAmount: number) {
    //Actions are only for user with Role ODPSupervisor
    if (recordsAmount != 0 && this.isSupervisorView) {  //&& this.isOdpSupervisor
      this.actionoptions = [];
      this.actionOptionSelected = "";
      if (this.metadata.menuActionOptions && this.metadata.menuActionOptions.length > 0) {
        this.metadata.menuActionOptions.forEach((action: MenuActionOption) => {
          if (action.filterOption == actionType) {
            let option: GenericSelectOption = {
              name: action.name,
              displayText: action.displayText,
              statusIds: "",
              recordsAmount: 0
            };
            if (action.name != 'removereview') {
              this.actionoptions.push(option);
            }
          }
        });
      }
    }
    else {
      this.actionoptions = [];
      this.actionOptionSelected = "";
    }
  }

  //Process data for the Filters list Select 
  public processMetadata() {
    this.filteroptions = [];

    var currentfilter = this.filterOptionSelected;
    this.qcAltView1DisplayText = "";
    this.qcAltView2DisplayText = "";
    if (this.isSupervisorView && this.isOdpSupervisor) {
      this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
        if (filter.userType == "ODPSupervisor") {
          let option: GenericSelectOption = {
            name: filter.filterOption,
            displayText: filter.displayText + " (" + filter.recordsAmount + ")",
            statusIds: filter.statusId,
            recordsAmount: filter.recordsAmount
          };

          /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
          /// * Originally, the following statements always reset the current filter
          /// to the default option ("all") after an action.
          /// * If another filter option was already selected, this caused a mismatch
          /// between the apparent selected filter option and the filtered results.
          /// * For example, if the user was viewing "In Review List" abstracts and
          /// removed one from the review list, that action would reset the filter to
          /// display "All Abstracts", but the results would still show only the remaining
          /// review list abstracts.
          /// * These statements also unnecessarily set the search keys and called "loadActions"
          /// after every filter option added to the filter list, not just the currently selected
          /// one, and always called "loadActions" for the "all" option.
          /// * To fix this, I included a check for the current filter; if it is null (as on initial
          /// page load), the selection is set to "all" and the search keys and load actions are
          /// set to the "all" option; otherwise these are set to the currently selected filter.
          /// * I did the same in the clauses for other roles below, which have different defaults.

          var defaultName = "all";
          if (option.name != "qceligible" && option.name != "qceligiblereview" && option.name != "qceligiblecoderqrev" && option.name != "qceligiblecoderodpadju") {
            this.filteroptions.push(option);

            if (option.name == "qceligible") {
              this.unfiltAllCount = option.recordsAmount;
              if (this.qcAltView1DisplayText == "") { this.qcAltView1DisplayText = option.displayText; };
            };
            if (option.name == "coderqrevuncoded") {
              this.unfiltCoderqCount = option.recordsAmount;
              if (this.qcAltView2DisplayText == "") { this.qcAltView2DisplayText = option.displayText; };
            }
            if (option.name == "reviewuncoded") {
              this.unfiltQCCount = option.recordsAmount;
              if ((currentfilter == "qceligible") || (currentfilter == "")) {
                this.qcAltView1DisplayText = option.displayText;
              } else if (currentfilter == "coderqrevuncoded") {
                this.qcAltView2DisplayText = option.displayText;
              };
            };
            if (currentfilter == "reviewuncoded") {
              this.qcViewQcList = true;
              this.qcViewCoderQList = false;
            } else if (currentfilter == "coderqrevuncoded") {
              this.qcViewQcList = false;
              this.qcViewCoderQList = true;
            } else {
              this.qcViewQcList = false;
              this.qcViewCoderQList = false;
            };
          };
          if ((currentfilter == "" && option.name == defaultName) || (option.name == currentfilter)) {
            this.filterOptionSelected = option.name;
            this.abstractSearchKeys.abstractFilterType = option.statusIds;
            this.loadActions(this.filterOptionSelected, option.recordsAmount);
          }
        }
      });
    }
    else {
      if (this.isStaffView && this.isOdpStaff) {
        this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
          if (filter.userType == "ODPStaff") {
            let option: GenericSelectOption = {
              name: filter.filterOption,
              displayText: filter.displayText + " (" + filter.recordsAmount + ")",
              statusIds: filter.statusId,
              recordsAmount: filter.recordsAmount
            };
            this.filteroptions.push(option);
            /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
            /// * See related notes in initial if clause above.
            if ((currentfilter == "" && option.name == "odpcompleted") || (option.name == currentfilter)) {
              this.filterOptionSelected = option.name;
              this.abstractSearchKeys.abstractFilterType = option.statusIds;
              //this.abstractSearchKeys.isInReview = true;
            }
          }
        });
      }
      else {
        if (this.isSupervisorView && this.isCoderSupervisor) {
          this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
            if (filter.userType == "CoderSupervisor") {
              let option: GenericSelectOption = {
                name: filter.filterOption,
                displayText: filter.displayText + " (" + filter.recordsAmount + ")",
                statusIds: filter.statusId,
                recordsAmount: filter.recordsAmount
              };
              this.filteroptions.push(option);
              /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
              /// * See related notes in initial if clause above.
              if ((currentfilter == "" && option.name == "all") || (option.name == currentfilter)) {
                this.filterOptionSelected = option.name;
                this.abstractSearchKeys.abstractFilterType = option.statusIds;
              }
            }
          });
        }
        else {
          if (this.isStaffView && this.isCoder) {
            this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
              if (filter.userType == "Coder") {
                let option: GenericSelectOption = {
                  name: filter.filterOption,
                  displayText: filter.displayText + " (" + filter.recordsAmount + ")",
                  statusIds: filter.statusId,
                  recordsAmount: filter.recordsAmount
                };
                this.filteroptions.push(option);
                /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
                /// * See related notes in initial if clause above.
                if ((currentfilter == "" && option.name == "codercompleted") || (option.name == currentfilter)) {
                  this.filterOptionSelected = option.name;
                  this.abstractSearchKeys.abstractFilterType = option.statusIds;
                  //this.abstractSearchKeys.isInReview = true;
                }
              }
            });
          }
          else {
            this.metadata.menuFilterOptions.forEach((filter: MenuFilterOption) => {
              if (filter.userType == "Admin") {
                let option: GenericSelectOption = {
                  name: filter.filterOption,
                  displayText: filter.displayText + " (" + filter.recordsAmount + ")",
                  statusIds: filter.statusId,
                  recordsAmount: filter.recordsAmount
                };
                this.filteroptions.push(option);
                /// [Notes:BJL_2023-08-02] Fix Abstract List filter handling
                /// * See related notes in initial if clause above.
                if ((currentfilter == "" && option.name == "default") || (option.name == currentfilter)) {
                  this.filterOptionSelected = option.name;
                  this.abstractSearchKeys.abstractFilterType = option.statusIds;
                }
              }
            });
          }
        }
      }
    }
  }

  public filterSelected(selectedOption: GenericSelectOption) {
    this.abstractSearchKeys.isInReview = false;
    this.abstractSearchKeys.recommendedForReview = false;
    this.abstractSearchKeys.isReportExcluded = false;
    this.abstractSearchKeys.recommendedForAdjudication = false;
    this.abstractSearchKeys.odpUncodedOnly = false;
    if (selectedOption.name.toLowerCase().includes('review')) {
      this.abstractSearchKeys.isInReview = true;
    }
    if (selectedOption.name.toLowerCase().includes('coderq')) {
      this.abstractSearchKeys.recommendedForReview = true;      
    }
    if (selectedOption.name.toLowerCase().includes('report')) {
      this.abstractSearchKeys.isReportExcluded = true;
    }
    if (selectedOption.name.toLowerCase().includes('coderodpadju')) {
      this.abstractSearchKeys.recommendedForAdjudication = true;
    }
    if (selectedOption.name.toLowerCase().includes('reviewuncoded')) {
      this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
      this.abstractSearchKeys.excludeAbstractsInQcList = false;
      this.qcViewQcList = true;
      this.qcViewCoderQList = false;
      this.abstractSearchKeys.odpUncodedOnly = true;
      //this.qcAltView1DisplayText = this.filteroptions.find(o => o.name.toLowerCase().includes('qceligible')).displayText;
      //this.qcAltView2DisplayText = this.filteroptions.find(o => o.name.toLowerCase().includes('coderqrevuncoded')).displayText;
    } else if (selectedOption.name.toLowerCase().includes('coderqrevuncoded')) {
      this.abstractSearchKeys.isInReview = true;
      this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
      this.abstractSearchKeys.excludeAbstractsInQcList = false;
      this.qcViewQcList = false;
      this.qcViewCoderQList = true;
      this.abstractSearchKeys.odpUncodedOnly = true;
      //this.qcAltView1DisplayText = this.filteroptions.find(o => o.name.toLowerCase().includes('qceligible')).displayText;
      //this.qcAltView2DisplayText = this.filteroptions.find(o => o.name.toLowerCase().includes('reviewuncoded')).displayText;
    }
    else if (selectedOption.name.toLowerCase().includes('coderodpadjuuncoded')) {
      this.abstractSearchKeys.isInReview = true;
      this.qcViewQcList = false;
      this.qcViewCoderQList = false;
      this.abstractSearchKeys.odpUncodedOnly = true;
    }
    else if (selectedOption.name.toLowerCase().includes('coderqrevcompleted')) {
      this.qcViewQcList = false;
      this.qcViewCoderQList = true;
      this.abstractSearchKeys.isInReview = false;
    }
    else if (selectedOption.name.toLowerCase().includes('coderodpadjucompleted')) {
      this.qcViewQcList = false;
      this.qcViewCoderQList = false;
      this.abstractSearchKeys.isInReview = false;
    }
    else {
      this.qcViewQcList = false;
      this.qcViewCoderQList = false;
      this.abstractSearchKeys.excludeAbstractsRecommendedForReview = false;
      this.abstractSearchKeys.excludeAbstractsInQcList = false;
      this.abstractSearchKeys.odpUncodedOnly = false;
      //this.qcAltView1DisplayText = this.filteroptions.find(o => o.name.toLowerCase().includes('reviewuncoded')).displayText;
      //this.qcAltView2DisplayText = this.filteroptions.find(o => o.name.toLowerCase().includes('coderqrevuncoded')).displayText;
    }
    

    this.abstractSearchKeys.abstractFilterType = selectedOption.statusIds;
    this.abstractSearchKeys.pageNumber = 0;
    this.paginator.forEach(p => p.pageIndex = 0);

    this.loadActions(selectedOption.name, selectedOption.recordsAmount);
    this.clearSearchTerm(); // Runs loadAbstractData()
  }


  public submitAction() {

    this.isLoadingResults = true;
    var selectedabscount = 0;
    var selectedabstrs = this.selection.selected;
    var abstractProtocolIds = [];
    this.selection.selected.forEach((selab) => {
      abstractProtocolIds.push(selab.abstractProtocolId);
      selectedabscount++;
    });

    if (this.actionOptionSelected == "exportabstracts") {
      this.exportAsXLSX();
      this.loadingIndicator = false;
      this.isLoadingResults = false;
      this.isRateLimitReached = false;
      this.clearSelected(selectedabstrs);
      //});
      return;
    };

    this.processSubmit(abstractProtocolIds);
    this.clearSelected(selectedabstrs);

    this.loadingIndicator = false;
    this.isLoadingResults = false;
    this.isRateLimitReached = false;

    /* };*/

  }

  public processSubmit(abstractProtocolIds) {
    let actionAbstracts: ActionAbstracts = {
      actionType: this.actionOptionSelected,
      abstractProtocolIds: abstractProtocolIds
    };

    this.abstractService.changeAbstractsStatus(actionAbstracts, this.accountService.GetActiveProject().odpProjectWorkflowId)
      .subscribe({
        next: abstractsResult => {
        this.alertService.stopLoadingMessage();
        if (abstractsResult) {
          this.loadAbstractSearchMetaData(this.protocolSelected);
        }
        this.loadingIndicator = false;
        this.isLoadingResults = false;
        this.isRateLimitReached = false;
      }, error:  error => {
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.alertService.showStickyMessage("Submit Action Error", `Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }});

  }

  public clearSelected(selectedabstrs) {

    ///// [Notes:BJL_2023-08-02]  Fix Abstract List filter handling
    /////The array "this.selection.selected" defines the abstracts to perform an action on.
    ///// * Originally, the array persisted after an action was performed, and abstracts selected for the next action
    ///// were added to the existing array. It was unclear when and how the array was reset. 
    ///// * This caused the following error when multiple actions were performed on a given abstract (e.g. adding an 
    ///// abstract to the review list, and then removing it):
    /////   "System.InvalidOperationException: 'The instance of entity type 'AbstractProtocol' cannot be tracked because
    /////   another instance with the same key value for { 'Id'} is already being tracked."
    ///// * This also caused actions to be performed on the wrong abstracts - for example, when abstracts were added 
    ///// to the review list, and then other abstracts were removed, the correctly-added ones were still in the array, 
    ///// and were also removed.
    ///// * To fix this, I added the code below, to remove all items from "this.selection.selected" after an action.
    selectedabstrs.forEach((selab) => {
      this.selection.deselect(selab);
    });

  }

  /// [Notes:BJL_2024-05-08]  Add random QC list selection handling
  public randomSelectQcList() {
    var totalQCEligAvail = this.abstractsData.abstractCount - this.abstractsData.inCoderQListCount;
    if (totalQCEligAvail == 0) {
      this.bottomSheet.open(ConfirmBottomSheetComponent, {
        data: {
          sheetTitle: "Auto-Select QC List",
          buttonText: "OK",
          sheetHtml: "There are 0 abstracts available for the QC list. Adjust the filters to make abstracts available for selection."
        },
        closeOnNavigation: true
      });
    } else {
      this.bottomSheet.open(DecisionBottomSheetComponent, {
        data: {
          sheetTitle: "Auto-Select QC List",
          sheetHtml: "This will randomly select a new QC list from the " + totalQCEligAvail + " eligible abstracts available (excludes Coder Question List), and will clear the current QC list. Do you want to proceed? "
        }
      }).afterDismissed().subscribe(isOk => {
        if (isOk) {
          this.isLoadingResults = true;

          var selectedabstrs = this.selection.selected;

          /// Remove ALL abstracts in QC selection pool from QC list and clear "inReviewList" from Mechanisms
          /// NOTE: the "resetallqcuncoded" actionType calls a function that finds ALL the required abstracts using an 
          /// internal query, so the abstractProtocolIds param is set to an empty list
          var resetAbPros = [];
          let actionRemoveQCAbstracts: ActionAbstracts = {
            actionType: "resetallqcuncoded",
            abstractProtocolIds: resetAbPros
            ////abstractProtocolIds: this.abProIdsFullForQCReset
          };
          this.abstractService.changeAbstractsStatus(actionRemoveQCAbstracts, this.accountService.GetActiveProject().odpProjectWorkflowId)
            .subscribe({ next: abstractsResult => {
              this.alertService.stopLoadingMessage();
              if (abstractsResult) {

                /// Select sampleN abstracts from each Mechanism in QC selection pool:
                var abstractsSelectQC = [];

                this.qcMechGrps.forEach((grp) => {
                  var randmax = grp.ingrpabpros.length - 1;
                  var randmin = 0;
                  while (grp.qcselectedcount < grp.sampleN) {
                    var abproselected = 0;
                    var randindex = Math.floor(Math.random() * (randmax - randmin + 1) + randmin);
                    var randabpro = grp.ingrpabpros[randindex];
                    while (abproselected == 0) {
                      if (!abstractsSelectQC.includes(randabpro.abstractProtocolId)) {
                        abproselected = 1;
                        randabpro.inReviewList = true;
                        abstractsSelectQC.push(randabpro.abstractProtocolId);
                        grp.qcselectedcount++;
                      } else {
                        randindex++;
                        randabpro = grp.ingrpabpros[randindex];
                      };
                    };
                  };
                });

                /// Add all randomly selected abstracts to QC list and reload results list
                let actionAddQCAbstracts: ActionAbstracts = {
                  actionType: "addreview",
                  abstractProtocolIds: abstractsSelectQC
                };

                this.abstractService.changeAbstractsStatus(actionAddQCAbstracts, this.accountService.GetActiveProject().odpProjectWorkflowId)
                  .subscribe({
                    next: abstractsResult => {
                    this.alertService.stopLoadingMessage();
                    if (abstractsResult) {
                      this.loadAbstractSearchMetaData(this.protocolSelected);
                    }
                    this.loadingIndicator = false;
                    this.isLoadingResults = false;
                    this.isRateLimitReached = false;
                  }, error:  error => {
                      this.alertService.stopLoadingMessage();
                      this.loadingIndicator = false;
                      this.alertService.showStickyMessage("Load Error", `RANDOM SELECT: Add - Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
                        MessageSeverity.error, error);
                    }});
              }
              this.loadingIndicator = false;
              this.isLoadingResults = false;
              this.isRateLimitReached = false;
            }, error: error => {
                this.alertService.stopLoadingMessage();
                this.loadingIndicator = false;
                this.alertService.showStickyMessage("Load Error", `RANDOM SELECT: Remove - Unable to retrieve abstracts from the server.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
                  MessageSeverity.error, error);
              }});

          selectedabstrs.forEach((selab) => {
            this.selection.deselect(selab);
          })
        }
      });

    };

  }

  /// [Notes:BJL_2024-05-23]  Open all abstracts in QC or Coder Q list for print to pdf
  public openPrintPdfWindow() {
    var keys = this.abstractSearchKeys;
    window.open(`#/abstract/print/0/${keys.abstractFilterType}/${keys.filterByProtocol}/${keys.isInReview}/${keys.recommendedForReview}/${keys.isReportExcluded}/${keys.protocolId}/${keys.sortColumnName}/${keys.sortDirection}`, "_blank");
  }



  //not used
  public actionChange(action: any) {

    //console.log(action)
    //console.log(this.selection)

    //console.log(this.selection.selected)

    ////this.isLoadingResults = true;

    //var abstractIds = [];
    //this.selection.selected.forEach(function (obj) {
    //  console.log(obj)
    //  abstractIds.push(obj.abstractId);
    //})

    //let actionAbstracts: ActionAbstracts = {
    //  actionType: action,
    //  abstractProtocolIds: abstractIds
    //};
    //console.log(actionAbstracts)
  }

  public highlight(row) {
    this.selectedRowIndex = row.abstractId;
    console.log(row)
  }

  /** Whether the number of selected elements matches the total number of rows. */
  public isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  public masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.forEach(row => this.selection.select(row));
  }
}
